import {observer, React} from '@api'
import {LookupItemListRenderer} from '@modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/LookupItemListRenderer'
import {useCatalog} from '@stores'
import {useAsync} from 'react-use'
import * as css from './C8AttributesSelectFieldRenderer.css'
import { EnumListRenderer } from '.'

export const C8AttributesSelectFieldRenderer = observer<{ c8Enum: string, subtype: string }>(function C8AttributesSelectFieldRenderer({c8Enum, subtype}) {
  const {c8} = useCatalog();

  const  enumData = c8Enum && useAsync(async () => await c8.getEnumValuesC8(c8Enum))

  const data = subtype && useAsync(async() => await c8.getC8LookupItemBySubtype(subtype))
  return subtype ? <div className={css.root} data-type={'C8LookupItemDropDown'} data-c8-sub-type={subtype}>
    {!data?.loading && !data?.value?.length ? <div className={css.noResults}>No results found.</div>
                                   : <LookupItemListRenderer lookupItems={data?.value} lookupItemList={false}/>}
  </div> : <div className={css.root} data-type={'C8EnumDropdown'} data-loading={enumData?.loading} data-c8-enum-type={c8Enum}>
    {!enumData?.loading && !enumData?.value?.length ? <div className={css.noResults}>No results found.</div>
                                   : <EnumListRenderer enumList={false} />}
  </div>
})



// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/C8AttributesSelectFieldRenderer.tsx